import type { AlarmContacts } from "@visioni/a3s-alarm-schedules/schema";
import { useUpdateCameraContacts } from "@src/services/api/hooks";
import { useTenantId } from "@src/features/tenants";

export type SubmitEmailCallbacks = {
  onSuccess: () => void;
  onError: (error: { message: string }) => void;
};

export type SubmitEmailParams = {
  email: string;
};

export type EmailContactSubmitOptions = {
  siteId?: string;
  cameraKey?: string;
  cameraContacts?: AlarmContacts | null;
};

export function useEmailContactSubmit(options: EmailContactSubmitOptions) {
  const tenantId = useTenantId();
  const updateCameraContactsMutation = useUpdateCameraContacts();

  const hasCameraContext = Boolean(tenantId && options.siteId && options.cameraKey);

  const submitEmail = (params: SubmitEmailParams, callbacks: SubmitEmailCallbacks) => {
    const { email } = params;

    if (!hasCameraContext) {
      console.error("useEmailContactSubmit called without tenantId/siteId/cameraKey");
      return;
    }

    const current: AlarmContacts = options.cameraContacts ?? {
      sms_contacts: [],
      email_contacts: [],
    };

    const next: AlarmContacts = {
      ...current,
      email_contacts: [...current.email_contacts, { email }],
    };

    updateCameraContactsMutation.mutate(
      {
        siteId: options.siteId!,
        cameraKey: options.cameraKey!,
        contacts: next,
      },
      {
        onSuccess: callbacks.onSuccess,
        onError: callbacks.onError,
      },
    );
  };

  return {
    submitEmail,
    isSubmitting: updateCameraContactsMutation.isPending,
  };
}
